var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuLandingPageLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m372.467 75.8-41.216 375.467H166.216L125 75.8z",
    style: {},
    fill: "#1566C0",
    "data-original": "#1566c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.867 75.8-41.216 375.467H166.216L125 75.8z",
    style: {},
    fill: "#2296F3",
    "data-original": "#2296f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.108 365.933v76.8H284.94a8.61 8.61 0 0 0-5.973 2.475L238.775 485.4l-40.192-40.192a8.61 8.61 0 0 0-5.973-2.475H51.042v-76.8h273.066z",
    style: {},
    fill: "#2E7D32",
    "data-original": "#2e7d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.508 365.933v76.8H259.34a8.61 8.61 0 0 0-5.973 2.475L213.175 485.4l-40.192-40.192a8.61 8.61 0 0 0-5.973-2.475H51.042v-76.8h247.466z",
    style: {},
    fill: "#4CAF50",
    "data-original": "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.623 355.523A25.598 25.598 0 0 1 324.108 383H52.467c-13.785.295-25.501-10.012-26.965-23.723a25.601 25.601 0 0 1 25.54-27.477h271.616c.485-.014.971.014 1.451.085 13.227.369 24.137 10.477 25.514 23.638z",
    style: {},
    fill: "#4E342E",
    "data-original": "#4e342e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.19 346.989a25.603 25.603 0 0 1-25.523 27.477H49.659c-13.785.295-25.501-10.012-26.965-23.723A25.6 25.6 0 0 1 48.2 323.265h246.016c.485-.014.971.014 1.451.085 13.231.367 24.146 10.475 25.523 23.639z",
    style: {},
    fill: "#795548",
    "data-original": "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.267 263.533v59.819a8.286 8.286 0 0 0-1.451-.085H196.765a8.61 8.61 0 0 0-5.973 2.475l-48.725 48.725-48.725-48.725a8.61 8.61 0 0 0-5.973-2.475H48.2v-59.733h273.067z",
    style: {},
    fill: "#FDD834",
    "data-original": "#fdd834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.667 267.8v59.819a8.286 8.286 0 0 0-1.451-.085H171.165a8.61 8.61 0 0 0-5.973 2.475l-35.925 35.925-35.925-35.925a8.61 8.61 0 0 0-5.973-2.475H48.2V267.8h247.467z",
    style: {},
    fill: "#FFEB3A",
    "data-original": "#ffeb3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.708 272.067v8.533a8.533 8.533 0 0 1-8.533 8.533h-307.2a8.533 8.533 0 0 1-8.533-8.533v-8.533c0-47.128 38.205-85.333 85.333-85.333h153.6c47.128-.001 85.333 38.204 85.333 85.333z",
    style: {},
    fill: "#F57C00",
    "data-original": "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.575 272.067v8.533a8.533 8.533 0 0 1-8.533 8.533H33.975a8.533 8.533 0 0 1-8.533-8.533v-8.533c0-47.128 38.205-85.333 85.333-85.333h119.467c47.128-.001 85.333 38.204 85.333 85.333zM315.575 434.2v25.6c0 28.277-22.923 51.2-51.2 51.2H76.642c-28.277 0-51.2-22.923-51.2-51.2v-25.6a8.533 8.533 0 0 1 8.533-8.533H192.61a8.61 8.61 0 0 1 5.973 2.475l40.192 40.192 40.192-40.192a8.61 8.61 0 0 1 5.973-2.475h22.101a8.533 8.533 0 0 1 8.534 8.533z",
    style: {},
    fill: "#FF9801",
    "data-original": "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.933 24.6v34.133h-230.4V24.6c.028-9.414 7.653-17.039 17.067-17.067h196.267c9.414.028 17.038 7.653 17.066 17.067z",
    style: {},
    fill: "#CFD8DC",
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.533 58.733V75.8A8.533 8.533 0 0 1 381 84.333H116.467a8.533 8.533 0 0 1-8.533-8.533V58.733c.028-9.414 7.653-17.039 17.067-17.067h247.467c9.413.029 17.037 7.653 17.065 17.067z",
    style: {},
    fill: "#CFD8DC",
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.333 24.6v34.133h-230.4c.028-9.414 7.653-17.039 17.067-17.067h8.533V24.6c.028-9.414 7.653-17.039 17.067-17.067h170.667c9.414.028 17.038 7.653 17.066 17.067z",
    style: {},
    fill: "#F4F4F4",
    "data-original": "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.933 58.733V75.8a8.533 8.533 0 0 1-8.533 8.533H116.467a8.533 8.533 0 0 1-8.533-8.533V58.733c.028-9.414 7.653-17.039 17.067-17.067h221.867c9.413.029 17.037 7.653 17.065 17.067z",
    style: {},
    fill: "#F4F4F4",
    "data-original": "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.315 288.28-32.853 214.187H260.253l-32.768-214.101a6.673 6.673 0 0 1 4.864-7.509 6.073 6.073 0 0 1 1.792-.256h7.339c1.024 0 1.963.085 2.987.171l188.416 1.621 22.955.171h1.963a34.768 34.768 0 0 1 11.52-1.963h7.253a6.705 6.705 0 0 1 6.741 7.679z",
    style: {},
    fill: "#C52828",
    "data-original": "#c52828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.715 288.28-32.853 214.187H260.253l-32.768-214.101a6.673 6.673 0 0 1 4.864-7.509l199.851 1.707a2.02 2.02 0 0 1 .683-.171 32.81 32.81 0 0 1 10.837-1.792h7.253a7.135 7.135 0 0 1 4.864 1.963 6.577 6.577 0 0 1 1.878 5.716z",
    style: {},
    fill: "#F44335",
    "data-original": "#f44335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.543 353.219a107.42 107.42 0 0 1-43.264-1.877l.521-2.475V201.923a6.665 6.665 0 0 1 6.656-6.656h29.355a6.665 6.665 0 0 1 6.656 6.656v150.699l.076.597zM287.133 246.467V325.4a85.745 85.745 0 0 1-14.251-23.893 33.544 33.544 0 0 0-28.416-20.736v-27.648a6.665 6.665 0 0 1 6.656-6.656h36.011z",
    style: {},
    fill: "#FFB301",
    "data-original": "#ffb301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.8 209.859v136.533l-.512 2.475h-.085a78.738 78.738 0 0 1-42.069-25.941V216.515a6.665 6.665 0 0 1 6.656-6.656h36.01zM415.987 333.165a82.281 82.281 0 0 1-43.435 20.053l-.085-.597V212.333H406.6a8.533 8.533 0 0 1 8.533 8.533v111.275l.854 1.024z",
    style: {},
    fill: "#FDD834",
    "data-original": "#fdd834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.8 244.589v37.973a33.283 33.283 0 0 0-19.883 18.944 83.456 83.456 0 0 1-21.845 31.659h-.085l-.853-1.024v-94.208h36.011a6.665 6.665 0 0 1 6.655 6.656z",
    style: {},
    fill: "#FFB301",
    "data-original": "#ffb301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.533 429.933c0 21.208-17.192 38.4-38.4 38.4a37.36 37.36 0 0 1-12.8-2.219 38.4 38.4 0 0 1 0-72.362 37.385 37.385 0 0 1 12.8-2.219c21.208 0 38.4 17.193 38.4 38.4z",
    style: {},
    fill: "#CFD8DC",
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.333,
    cy: 429.933,
    rx: 25.6,
    ry: 36.181,
    style: {},
    fill: "#F4F4F4",
    "data-original": "#f4f4f4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.933 230.4h8.533a8.533 8.533 0 0 0 0-17.066h-8.533a8.533 8.533 0 0 0 0 17.066zM162.133 247.467h8.533a8.533 8.533 0 0 0 0-17.066h-8.533a8.533 8.533 0 0 0 0 17.066zM213.333 230.4h8.533a8.533 8.533 0 0 0 0-17.066h-8.533a8.533 8.533 0 0 0 0 17.066z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.467 494.933h-40.055l31.36-204.433c.64-4.37-.66-8.802-3.558-12.134a15.36 15.36 0 0 0-11.639-5.299h-7.313c-1.007 0-1.971.154-2.961.213v-27.691c-.005-8.374-6.782-15.166-15.155-15.189h-27.477v-17.067a8.533 8.533 0 0 0-8.533-8.533H384v-1.877a15.205 15.205 0 0 0-11.878-14.805l10.94-94.251h9.472a8.533 8.533 0 0 0 8.533-8.533v-25.6c0-14.138-11.462-25.6-25.6-25.6V25.6c0-14.138-11.462-25.6-25.6-25.6H153.6C139.462 0 128 11.462 128 25.6v8.533c-14.138 0-25.6 11.462-25.6 25.6v25.6a8.533 8.533 0 0 0 8.533 8.533h9.472l8.934 76.8h-18.406c-51.816.061-93.806 42.051-93.867 93.867v8.533c0 9.426 7.641 17.067 17.067 17.067h8.533v26.812c-15.987 4.007-26.757 18.955-25.498 35.388a34.295 34.295 0 0 0 25.498 30.14V409.6h-8.533c-9.426 0-17.067 7.641-17.067 17.067v25.6a59.542 59.542 0 0 0 18.005 42.667H8.533a8.533 8.533 0 0 0 0 17.066h494.933a8.533 8.533 0 0 0 8.533-8.533 8.532 8.532 0 0 0-8.532-8.534zm-25.907-204.8-31.411 204.801H270.583l-31.351-204.801 5.214.001a25.294 25.294 0 0 1 23.501 15.522 94.778 94.778 0 0 0 15.582 26.155c.302.423.645.814 1.024 1.169a95.038 95.038 0 0 0 73.847 31.113c42.667 0 75.605-21.333 90.453-58.445a25.294 25.294 0 0 1 23.441-15.514l5.266-.001zM366.933 204.8v141.705c-2.825.222-5.615.521-8.533.521a99.992 99.992 0 0 1-17.067-1.579V204.8h25.6zm-42.666 17.067v118.869a69.79 69.79 0 0 1-25.6-17.724V221.867h25.6zM281.6 294.886a41.578 41.578 0 0 0-25.6-20.207V256h25.6v38.886zm-47.872 72.047h-68.07l34.133-34.133h28.74l5.197 34.133zm218.539-119.466v30.583a41.284 41.284 0 0 0-19.311 21.265 82.571 82.571 0 0 1-6.289 12.382v-64.23h25.6zm-42.667-25.6V330.82a73.156 73.156 0 0 1-25.6 12.868V221.867h25.6zM145.067 25.6a8.533 8.533 0 0 1 8.533-8.533h196.267A8.533 8.533 0 0 1 358.4 25.6v8.533H145.067V25.6zm-25.6 34.133A8.533 8.533 0 0 1 128 51.2h247.467A8.533 8.533 0 0 1 384 59.733V76.8H119.467V59.733zm18.116 34.134h228.301l-10.897 93.867h-15.531a15.2 15.2 0 0 0-12.638 6.775 92.738 92.738 0 0 0-58.317-23.731c-1.323-.111-2.645-.111-3.968-.111H146.517l-8.934-76.8zM34.133 264.533c.052-42.394 34.406-76.748 76.8-76.8h153.6c.896 0 1.783 0 3.004.077a76.23 76.23 0 0 1 45.099 16.99H296.79c-8.387.005-15.185 6.802-15.189 15.189v18.944h-27.477c-8.387.005-15.185 6.802-15.189 15.189v18.944h-204.8v-8.533zm187.887 25.6v.486l3.874 25.114h-26.129a17.068 17.068 0 0 0-12.032 4.975l-42.667 42.667-42.666-42.667a17.068 17.068 0 0 0-12.032-4.975H59.733v-25.6H222.02zM34.193 351.104a16.738 16.738 0 0 1 4.949-13.295A16.917 16.917 0 0 1 51.2 332.8h39.108l34.133 34.133h-71.79c-9.306.25-17.286-6.594-18.458-15.829zM59.733 384h176.64l8.943 58.385-6.383 6.349-34.133-34.133a17.066 17.066 0 0 0-12.032-5.001H59.733V384zm-25.6 68.267v-25.6H192.691l40.192 40.192a8.534 8.534 0 0 0 12.066 0l3.516-3.516 4.847 31.573H76.8c-23.546-.028-42.629-19.103-42.667-42.649z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354.133 384a46.934 46.934 0 1 0 46.933 46.933c-.028-25.908-21.024-46.905-46.933-46.933zm0 76.8c-16.495 0-29.867-13.372-29.867-29.867s13.372-29.867 29.867-29.867S384 414.438 384 430.933 370.628 460.8 354.133 460.8z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLandingPageLogo);
export default __webpack_public_path__ + "static/media/Menu_LandingPage_Logo.bada28e18e20db583d0b2033650b3f15.svg";
export { ForwardRef as ReactComponent };